<template src='./PackageConfigList.html'></template>
<script>
import { orderBy } from "@progress/kendo-data-query";
import CommandCell from "@/components/CommandCellTemplate.vue";
// import { createNamespacedHelpers } from "vuex";
// const { mapState } = createNamespacedHelpers("packageConfig");
// import { MESSAGES } from "@/utils/constants";
// import { notify, notifyApiError } from "@/utils/notification-helper";
import DialogBox from "@/components/DialogBox.vue";

export default {
  data: function() {
    return {
      // addoredit: false,
      gridData: [],
      skip: 0,
      take: 10,
      pageSize: 10,
      pageable: {
        pageSizes: true,
        previousNext: true
      },
      add: true,
      sort: [{ field: "id", dir: "asc" }],
      columns: [
        { field: "id", title: "ID" },
        { field: "name", title: "Name" },

        { field: "productName", title: "Product" },

        { cell: CommandCell, title: "Actions", width: "200px" }
      ],
      dataItems: [],
      removeData:{}
    };
  },
  components: {
    DialogBox
  },
  methods: {
    sortChangeHandler: function(e) {
      this.sort = e.sort;
    },
    pageChangeHandler: function(event) {
      this.skip = event.page.skip;
      this.take = event.page.take;
    },
    showAdd: function() {
      this.add = true;
    },
    remove: function(item) {
      this.removeData = item;
      this.$refs.removeTenantDtl.openWindow();
    },
    OkMethod() {
      return this.$store
        .dispatch("packageConfig/removePackage", this.removeData)
        .then(() => {
          //   notify(MESSAGES.CHANGES_SAVE_SUCCESS);
        });
      // .catch(notifyApiError);
    },
    closeDialog() {
      this.$refs.removeTenantDtl.closeWindow();
    },
    edit: function(item) {
      return this.$store.dispatch("packageConfig/editPackage", item.dataItem); //item.dataItem.id
    },
    async getDataOnload() {
      this.$store.dispatch("getPackage");
    }
  },
  computed: {
    // ...mapState({
    //   packList: state => state.packs
    // }),
    packList() {
      return this.$store.state.packageData;
    },
    total() {
      return this.packList ? this.packList.length : 0;
    },
    items: {
      get: function() {
        return orderBy(
          this.packList.slice(this.skip, this.take + this.skip),
          this.sort
        );
      }
    }
  },
  created: function() {
    this.getDataOnload();
  }
};
</script>
